import { styled } from '@mui/system';
import MuiCheckbox from '@mui/material/Checkbox';
import colors from '../../assets/colors';

const StyledCheckbox = styled(MuiCheckbox)({
  color: colors.agroweGreen,
  '&.Mui-checked': {
    color: colors.agroweGreen,
  },
});

const Checkbox = (props) => <StyledCheckbox color="default" {...props} />;
export default Checkbox;
